import PropTypes from 'react-proptypes';
const {string, shape} = PropTypes;
import ToolLogoSvg from 'images/hnk/logo.svg';

export default {
  app: 'hnk',
  logo: ToolLogoSvg,
  framed: false,
  pages: [
    'landing',
    'applicant',
    'partner',
    'final',
  ],
  syncing: false,
  broken: false,
  recalculating: null,
  settings: null,
  input: {
    // landing
    rent_per_month: null,
    // income
    applicant_dob: '',
    applicant_income: null,
    applicant_income_period: 'monthly',
    applicant_holiday_bonus: true,
    applicant_13th_month_salary: false,
    applicant_is_entrepreneur: false,
    applicant_is_entrepreneur_for_three_years: true,
    applicant_entrepreneur_prognoses_current_year: null,
    applicant_entrepreneur_fiscal_profit_last_year: null,
    applicant_entrepreneur_fiscal_profit_two_years_ago: null,
    applicant_entrepreneur_fiscal_profit_three_years_ago: null,
    applicant_pension_income: null,
    applicant_pension_income_period: 'yearly',
    // partner
    applicant_has_partner: false,
    partner_dob: '',
    partner_income: null,
    partner_income_period: 'monthly',
    partner_holiday_bonus: true,
    partner_13th_month_salary: false,
    partner_is_entrepreneur: false,
    partner_is_entrepreneur_for_three_years: true,
    partner_entrepreneur_prognoses_current_year: null,
    partner_entrepreneur_fiscal_profit_last_year: null,
    partner_entrepreneur_fiscal_profit_two_years_ago: null,
    partner_entrepreneur_fiscal_profit_three_years_ago: null,
    partner_pension_income: null,
    partner_pension_income_period: 'yearly',
  },
  output: {
    errors: {},
  },
};

export const whiteListUrlParams = [
  // landing
  'rent_per_month',
  // income
  'applicant_dob',
  'applicant_income',
  'applicant_income_period',
  'applicant_holiday_bonus',
  'applicant_13th_month_salary',
  'applicant_is_entrepreneur',
  'applicant_is_entrepreneur_for_three_years',
  'applicant_entrepreneur_prognoses_current_year',
  'applicant_entrepreneur_fiscal_profit_last_year',
  'applicant_entrepreneur_fiscal_profit_two_years_ago',
  'applicant_entrepreneur_fiscal_profit_three_years_ago',
  'applicant_pension_income',
  'applicant_pension_income_period',
  // partner
  'applicant_has_partner',
  'partner_dob',
  'partner_income',
  'partner_income_period',
  'partner_holiday_bonus',
  'partner_13th_month_salary',
  'partner_is_entrepreneur',
  'partner_is_entrepreneur_for_three_years',
  'partner_entrepreneur_prognoses_current_year',
  'partner_entrepreneur_fiscal_profit_last_year',
  'partner_entrepreneur_fiscal_profit_two_years_ago',
  'partner_entrepreneur_fiscal_profit_three_years_ago',
  'partner_pension_income',
  'partner_pension_income_period',
];

export const dob = shape({
  day: string,
  month: string,
  year: string,
  value: string,
});
